var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19594_52017)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15V13C20 11.9 19.1 11 18 11H12C10.9 11 10 11.9 10 13V27C10 28.1 10.9 29 12 29H28C29.1 29 30 28.1 30 27V17C30 15.9 29.1 15 28 15H20ZM18 27H12V25H18V27ZM18 23H12V21H18V23ZM18 19H12V17H18V19ZM18 15H12V13H18V15ZM28 27H20V17H28V27ZM26 19H22V21H26V19ZM26 23H22V25H26V23Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19594_52017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.06d11b0b763cee487590533e14b0b247.svg";
export { ForwardRef as ReactComponent };